module.exports = __webpack_public_path__ + "static/media/cent.030403b6.png";